import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Backdrop from "./Backdrop";
import Spacer from "./Spacer";
import Button from "./Button";
import HappyEmojiGroup from "assets/images/happy-emoji-group.png";
import { reactivateAccount, getUserAccounts } from "api";
import { showAlert } from "utils/utils";
import { connect } from "react-redux";

const Wrapper = styled(Backdrop)`
  .modal {
    border-radius: 16px;
    width: 480px;
    padding: 48px;
    background-color: #fff;
  }

  .header {
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    margin-bottom: 6px;
  }

  .content {
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    color: var(--body_text);
  }

  @media screen and (max-width: 768px) {
    .modal {
      width: 90%;
      padding: 24px;
    }
  }
`;

const WelcomeBack = ({ user, active_account }) => {
  const [showWelcomeBackModal, setShowWelcomeBackModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleActivateAccount = async () => {
    setIsSubmitting(true);
    try {
      const res = await reactivateAccount();
      if(res.data?.status === true) {
        getUserAccounts();
        setShowWelcomeBackModal(false)
        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);
      showAlert({
        type: "danger",
        msg: error.response?.data.message || error.message,
      });
    }
  };

  useEffect(() => {
    if (active_account?.status === 3) {
      setShowWelcomeBackModal(true);
    }
  }, [active_account]);

  return (
    <Wrapper
      className={`flexRow alignCenter justifyCenter ${
        showWelcomeBackModal && "show"
      }`}
    >
      <div className="modal">
        <div className="textCenter">
          <img src={HappyEmojiGroup} alt="emoji" height="36px" />
        </div>
        <Spacer y={1.2} />
        <header className="header textCenter">You're back on PostPaddy</header>
        <p className="content textCenter">
          The PostPaddy account associated with {user?.email} has been
          reactivated.
        </p>
        <p className="content textCenter">Welcome back!</p>
        <Spacer y={2.4} />
        <Button
          loading={isSubmitting}
          disabled={isSubmitting}
          text="Continue"
          fullWidth
          onClick={handleActivateAccount}
        />
      </div>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    active_account: state.active_account,
  };
};

export default connect(mapStateToProps)(WelcomeBack);
